// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
//   Paper, Button, Dialog, DialogTitle, DialogContent, DialogActions,
//   TextField, MenuItem, Box, IconButton, Tooltip, Chip, Select,
//   FormControl, InputLabel, Grid, Pagination, Stack, Typography
// } from "@mui/material";
// import ClearIcon from '@mui/icons-material/Clear';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import {
//   getAllVideosByStatusForAdmin,
//   updateVideoByAdmin,
//   deleteVideoByAdmin,
//   getAllReporters
// } from "../../../services/adminService";
// import { getCategories, getSubcategories } from "../../../services/apiService";

// const statusColor = {
//   pending_approval: "warning",
//   posted: "success",
//   rejected: "error",
// };

// const AllVideosAdminManagement = () => {
//   const [videos, setVideos] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [editingVideo, setEditingVideo] = useState(null);
//   const [formData, setFormData] = useState({
//     title: "", videoUrl: "", category: "", subCategory: "", status: "", videoFile: null
//   });
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);
//   const [reportersDropdown, setReportersDropdown] = useState([]);

//   const [filters, setFilters] = useState({
//     status: "all",
//     category: "",
//     reporter: "",
//     startDate: "",
//     endDate: "",
//     search: "",
//   });

//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);

//   const fetchVideos = useCallback(async (pageNumber = page) => {
//     try {
//       const data = await getAllVideosByStatusForAdmin({
//         page: pageNumber,
//         limit,
//         ...filters,
//       });
//       setVideos(data.data || []);
//       setTotalPages(data.totalPages || 1);
//     } catch (error) {
//       console.error("Error fetching videos:", error);
//     }
//   }, [limit, page, filters]);

//   useEffect(() => {
//     fetchVideos(page);
//   }, [fetchVideos, page]);

//   useEffect(() => {
//     const loadInitial = async () => {
//       try {
//         const [catsRes, reportersRes] = await Promise.all([
//           getCategories(),
//           getAllReporters(),
//         ]);
//         setCategories(catsRes.data || []);
//         setReportersDropdown(reportersRes.data || []);
//       } catch (error) {
//         console.error("Error loading dropdown data:", error);
//       }
//     };
//     loadInitial();
//   }, []);

//   useEffect(() => {
//     if (!formData.category) {
//       setSubcategories([]);
//       return;
//     }
//     const loadSubcategories = async () => {
//       try {
//         const res = await getSubcategories(formData.category);
//         setSubcategories(res.data || []);
//       } catch (error) {
//         console.error("Error loading subcategories:", error);
//       }
//     };
//     loadSubcategories();
//   }, [formData.category]);

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({ ...prev, [name]: value }));
//     setPage(1);
//   };

//   const clearFilters = () => {
//     setFilters({
//       status: "all",
//       category: "",
//       reporter: "",
//       startDate: "",
//       endDate: "",
//       search: "",
//     });
//     setPage(1);
//   };

//   const handleOpenDialog = (video) => {
//     setEditingVideo(video);
//     setFormData({
//       title: video.title || "",
//       videoUrl: video.videoUrl || "",
//       category: video.category || "",
//       subCategory: video.subCategory || "",
//       status: video.status || "",
//       videoFile: null,
//     });
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setEditingVideo(null);
//     setFormData({ title: "", videoUrl: "", category: "", subCategory: "", status: "", videoFile: null });
//     setSubcategories([]);
//   };

//   const handleSubmit = async () => {
//     try {
//       const data = new FormData();
//       data.append("title", formData.title);
//       if (formData.category) data.append("category", formData.category);
//       if (formData.subCategory) data.append("subCategory", formData.subCategory);
//       if (formData.status) data.append("status", formData.status);

//       if (formData.videoFile) {
//         data.append("videoFile", formData.videoFile);
//       } else if (formData.videoUrl) {
//         data.append("videoUrl", formData.videoUrl);
//       }

//       await updateVideoByAdmin(editingVideo._id, data);
//       fetchVideos(page);
//       handleCloseDialog();
//     } catch (error) {
//       console.error("Error updating video:", error);
//       alert(error.response?.data?.message || "Update failed");
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this video?")) return;
//     try {
//       await deleteVideoByAdmin(id);
//       fetchVideos(page);
//     } catch (error) {
//       console.error("Error deleting video:", error);
//     }
//   };

//   return (
//     <div className="p-4">
//       <Typography variant="h5" gutterBottom>
//         All Videos
//       </Typography>

//       {/* Filters - same pattern as News */}
//       <Paper sx={{ p: 2, mb: 3, backgroundColor: '#f5f7fa', borderRadius: 2 }}>
//         <Grid container spacing={2} alignItems="center">

//           {/* Reporter */}
//           <Grid item xs={12} sm={6} md={2.4}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Reporter</InputLabel>
//               <Select
//                 name="reporter"
//                 value={filters.reporter || ""}
//                 label="Reporter"
//                 onChange={handleFilterChange}
//               >
//                 <MenuItem value="">All Reporters</MenuItem>
//                 {reportersDropdown.map((rep) => (
//                   <MenuItem key={rep.id} value={rep.id}>
//                     {rep.name}{rep.city?.name ? ` (${rep.city.name})` : ''}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Status */}
//           <Grid item xs={12} sm={6} md={2.4}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Status</InputLabel>
//               <Select name="status" value={filters.status} label="Status" onChange={handleFilterChange}>
//                 <MenuItem value="all">All Status</MenuItem>
//                 <MenuItem value="pending_approval">Pending</MenuItem>
//                 <MenuItem value="posted">Posted</MenuItem>
//                 <MenuItem value="rejected">Rejected</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Category */}
//           <Grid item xs={12} sm={6} md={2.4}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Category</InputLabel>
//               <Select name="category" value={filters.category} label="Category" onChange={handleFilterChange}>
//                 <MenuItem value="">All Categories</MenuItem>
//                 {categories.map((cat) => (
//                   <MenuItem key={cat._id} value={cat._id}>
//                     {cat.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Search */}
//           <Grid item xs={12} sm={6} md={2.4}>
//             <TextField
//               fullWidth
//               size="small"
//               label="Search by title"
//               name="search"
//               value={filters.search}
//               onChange={handleFilterChange}
//             />
//           </Grid>

//           {/* Start Date */}
//           <Grid item xs={12} sm={6} md={3}>
//             <TextField
//               fullWidth
//               size="small"
//               type="date"
//               label="From Date"
//               name="startDate"
//               InputLabelProps={{ shrink: true }}
//               value={filters.startDate}
//               onChange={handleFilterChange}
//             />
//           </Grid>

//           {/* End Date */}
//           <Grid item xs={12} sm={6} md={3}>
//             <TextField
//               fullWidth
//               size="small"
//               type="date"
//               label="To Date"
//               name="endDate"
//               InputLabelProps={{ shrink: true }}
//               value={filters.endDate}
//               onChange={handleFilterChange}
//             />
//           </Grid>

//           {/* Clear Button */}
//           <Grid item xs={12} sm={6} md={3}>
//             <Button
//               fullWidth
//               variant="outlined"
//               color="secondary"
//               onClick={clearFilters}
//               startIcon={<ClearIcon />}
//               sx={{ height: "40px" }}
//             >
//               Clear Filters
//             </Button>
//           </Grid>

//         </Grid>
//       </Paper>

//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>#</TableCell>
//               <TableCell>Title</TableCell>
//               <TableCell>Category</TableCell>
//               <TableCell>SubCategory</TableCell>
//               <TableCell>Created By</TableCell>
//               <TableCell>Status</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {videos.map((video, idx) => (
//               <TableRow key={video._id}>
//                 <TableCell>{(page - 1) * limit + idx + 1}</TableCell>
//                 <TableCell>{video.title}</TableCell>
//                 <TableCell>{video.category}</TableCell>
//                 <TableCell>{video.subCategory}</TableCell>
//                 <TableCell>{video.createdBy?.name || video.createdBy?.username}</TableCell>
//                 <TableCell>
//                   <Chip
//                     label={video.status}
//                     color={statusColor[video.status] || "default"}
//                     size="small"
//                   />
//                 </TableCell>
//                 <TableCell>
//                   <Box display="flex" gap={1}>
//                     <Tooltip title="Edit">
//                       <IconButton color="primary" onClick={() => handleOpenDialog(video)} size="small">
//                         <EditIcon fontSize="small" />
//                       </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Delete">
//                       <IconButton color="error" onClick={() => handleDelete(video._id)} size="small">
//                         <DeleteIcon fontSize="small" />
//                       </IconButton>
//                     </Tooltip>
//                   </Box>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
//         <Pagination
//           count={totalPages}
//           page={page}
//           onChange={(e, value) => setPage(value)}
//           color="primary"
//         />
//         <Select
//           value={limit}
//           onChange={(e) => {
//             setLimit(e.target.value);
//             setPage(1);
//           }}
//           size="small"
//         >
//           {[5, 10, 20, 50].map((l) => (
//             <MenuItem key={l} value={l}>{l} per page</MenuItem>
//           ))}
//         </Select>
//       </Stack>

//       {/* Edit Dialog */}
//       <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
//         <DialogTitle>Edit Video</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="Title"
//             fullWidth
//             margin="dense"
//             value={formData.title}
//             onChange={(e) => setFormData({ ...formData, title: e.target.value })}
//           />

//           <TextField
//             label="Video URL"
//             fullWidth
//             margin="dense"
//             value={formData.videoUrl}
//             onChange={(e) => setFormData({ ...formData, videoUrl: e.target.value })}
//             disabled={!!formData.videoFile}
//           />

//           <Box mt={2} mb={1}>
//             <input
//               type="file"
//               accept="video/*"
//               onChange={(e) => setFormData({ ...formData, videoFile: e.target.files[0] })}
//               disabled={!!formData.videoUrl}
//             />
//           </Box>

//           <TextField
//             label="Category"
//             select
//             fullWidth
//             margin="dense"
//             value={formData.category}
//             onChange={(e) => setFormData({ ...formData, category: e.target.value })}
//           >
//             {categories.map(cat => (
//               <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             label="SubCategory"
//             select
//             fullWidth
//             margin="dense"
//             value={formData.subCategory}
//             onChange={(e) => setFormData({ ...formData, subCategory: e.target.value })}
//             disabled={!formData.category}
//           >
//             {subcategories.map(sub => (
//               <MenuItem key={sub._id} value={sub._id}>{sub.name}</MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             label="Status"
//             select
//             fullWidth
//             margin="dense"
//             value={formData.status}
//             onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//           >
//             <MenuItem value="pending_approval">Pending</MenuItem>
//             <MenuItem value="posted">Posted</MenuItem>
//             <MenuItem value="rejected">Rejected</MenuItem>
//           </TextField>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialog}>Cancel</Button>
//           <Button onClick={handleSubmit} variant="contained" color="primary">Update</Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default AllVideosAdminManagement;

import React, { useState, useEffect, useCallback } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, MenuItem, Box, IconButton, Tooltip, Chip, Select,
  FormControl, InputLabel, Grid, Pagination, Stack, Typography
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import {
  getAllVideosByStatusForAdmin,
  updateVideoByAdmin,
  deleteVideoByAdmin,
  getAllReporters
} from "../../../services/adminService";
import { getCategories, getSubcategories } from "../../../services/apiService";

const statusColor = {
  pending_approval: "warning",
  posted: "success",
  rejected: "error",
};

const getYouTubeId = (url) => {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

const AllVideosAdminManagement = () => {
  const [videos, setVideos] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingVideo, setEditingVideo] = useState(null);
  const [formData, setFormData] = useState({
    title: "", videoUrl: "", category: "", subCategory: "", status: "", videoFile: null
  });
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [reportersDropdown, setReportersDropdown] = useState([]);

  // Video player modal
  const [openPlayer, setOpenPlayer] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");

  const [filters, setFilters] = useState({
    status: "all",
    category: "",
    reporter: "",
    startDate: "",
    endDate: "",
    search: "",
  });

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchVideos = useCallback(async (pageNumber = page) => {
    try {
      const data = await getAllVideosByStatusForAdmin({
        page: pageNumber,
        limit,
        ...filters,
      });
      setVideos(data.data || []);
      setTotalPages(data.totalPages || 1);
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  }, [limit, page, filters]);

  useEffect(() => {
    fetchVideos(page);
  }, [fetchVideos, page]);

  useEffect(() => {
    const loadInitial = async () => {
      try {
        const [catsRes, reportersRes] = await Promise.all([
          getCategories(),
          getAllReporters(),
        ]);
        setCategories(catsRes.data || []);
        setReportersDropdown(reportersRes.data || []);
      } catch (error) {
        console.error("Error loading dropdown data:", error);
      }
    };
    loadInitial();
  }, []);

  // ✅ Load subcategories only when formData.category holds a valid ObjectId (from dropdown selection)
  useEffect(() => {
    if (!formData.category || !/^[0-9a-fA-F]{24}$/.test(formData.category)) {
      setSubcategories([]);
      return;
    }
    const loadSubcategories = async () => {
      try {
        const res = await getSubcategories(formData.category);
        setSubcategories(res.data || []);
      } catch (error) {
        console.error("Error loading subcategories:", error);
        setSubcategories([]);
      }
    };
    loadSubcategories();
  }, [formData.category]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setPage(1);
  };

  const clearFilters = () => {
    setFilters({
      status: "all",
      category: "",
      reporter: "",
      startDate: "",
      endDate: "",
      search: "",
    });
    setPage(1);
  };

  // ✅ KEY FIX: video.category / video.subCategory backend me NAME (string) store hoti hai,
  // dropdown ko _id chahiye. Isliye edit khulte waqt name → _id map karke fetch karte hain.
  const handleOpenDialog = async (video) => {
    setEditingVideo(video);

    // Match category name -> its _id
    const matchedCategory = categories.find(
      (cat) => cat.name === video.category
    );
    const categoryId = matchedCategory ? matchedCategory._id : "";

    let subCategoryId = "";
    if (categoryId) {
      try {
        const res = await getSubcategories(categoryId);
        const subs = res.data || [];
        setSubcategories(subs);
        const matchedSub = subs.find((sub) => sub.name === video.subCategory);
        subCategoryId = matchedSub ? matchedSub._id : "";
      } catch (error) {
        console.error("Error loading subcategories for edit:", error);
        setSubcategories([]);
      }
    } else {
      setSubcategories([]);
    }

    setFormData({
      title: video.title || "",
      videoUrl: video.videoUrl || "",
      category: categoryId,
      subCategory: subCategoryId,
      status: video.status || "",
      videoFile: null,
    });

    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingVideo(null);
    setFormData({ title: "", videoUrl: "", category: "", subCategory: "", status: "", videoFile: null });
    setSubcategories([]);
  };

  const handleSubmit = async () => {
    try {
      const data = new FormData();
      data.append("title", formData.title);
      if (formData.category) data.append("category", formData.category);
      if (formData.subCategory) data.append("subCategory", formData.subCategory);
      if (formData.status) data.append("status", formData.status);

      if (formData.videoFile) {
        data.append("videoFile", formData.videoFile);
      } else if (formData.videoUrl) {
        data.append("videoUrl", formData.videoUrl);
      }

      await updateVideoByAdmin(editingVideo._id, data);
      fetchVideos(page);
      handleCloseDialog();
    } catch (error) {
      console.error("Error updating video:", error);
      alert(error.response?.data?.message || "Update failed");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this video?")) return;
    try {
      await deleteVideoByAdmin(id);
      fetchVideos(page);
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };

  const handlePlayVideo = (url) => {
    setCurrentVideoUrl(url);
    setOpenPlayer(true);
  };

  const handleClosePlayer = () => {
    setCurrentVideoUrl("");
    setOpenPlayer(false);
  };

  return (
    <div className="p-4">
      <Typography variant="h5" gutterBottom>
        All Videos
      </Typography>

      {/* Filters */}
      <Paper sx={{ p: 2, mb: 3, backgroundColor: '#f5f7fa', borderRadius: 2 }}>
        <Grid container spacing={2} alignItems="center">

          <Grid item xs={12} sm={6} md={2.4}>
            <FormControl fullWidth size="small">
              <InputLabel>Reporter</InputLabel>
              <Select
                name="reporter"
                value={filters.reporter || ""}
                label="Reporter"
                onChange={handleFilterChange}
              >
                <MenuItem value="">All Reporters</MenuItem>
                {reportersDropdown.map((rep) => (
                  <MenuItem key={rep.id} value={rep.id}>
                    {rep.name}{rep.city?.name ? ` (${rep.city.name})` : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={2.4}>
            <FormControl fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select name="status" value={filters.status} label="Status" onChange={handleFilterChange}>
                <MenuItem value="all">All Status</MenuItem>
                <MenuItem value="pending_approval">Pending</MenuItem>
                <MenuItem value="posted">Posted</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={2.4}>
            <FormControl fullWidth size="small">
              <InputLabel>Category</InputLabel>
              <Select name="category" value={filters.category} label="Category" onChange={handleFilterChange}>
                <MenuItem value="">All Categories</MenuItem>
                {categories.map((cat) => (
                  <MenuItem key={cat._id} value={cat._id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={2.4}>
            <TextField
              fullWidth
              size="small"
              label="Search by title"
              name="search"
              value={filters.search}
              onChange={handleFilterChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              type="date"
              label="From Date"
              name="startDate"
              InputLabelProps={{ shrink: true }}
              value={filters.startDate}
              onChange={handleFilterChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              type="date"
              label="To Date"
              name="endDate"
              InputLabelProps={{ shrink: true }}
              value={filters.endDate}
              onChange={handleFilterChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={clearFilters}
              startIcon={<ClearIcon />}
              sx={{ height: "40px" }}
            >
              Clear Filters
            </Button>
          </Grid>

        </Grid>
      </Paper>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Video</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>SubCategory</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {videos.map((video, idx) => (
              <TableRow key={video._id}>
                <TableCell>{(page - 1) * limit + idx + 1}</TableCell>

                {/* ✅ Video thumbnail/preview column */}
                <TableCell>
                  {video.videoUrl && (video.videoUrl.includes("youtube.com") || video.videoUrl.includes("youtu.be")) ? (
                    <img
                      src={`https://img.youtube.com/vi/${getYouTubeId(video.videoUrl)}/0.jpg`}
                      alt={video.title}
                      style={{ width: "100px", cursor: "pointer", borderRadius: ".4rem" }}
                      onClick={() => handlePlayVideo(video.videoUrl)}
                    />
                  ) : video.videoUrl ? (
                    <video
                      src={video.videoUrl}
                      width="100"
                      style={{ cursor: "pointer", borderRadius: ".4rem" }}
                      onClick={() => handlePlayVideo(video.videoUrl)}
                    />
                  ) : (
                    <Typography variant="caption" color="textSecondary">No Media</Typography>
                  )}
                </TableCell>

                <TableCell>{video.title}</TableCell>
                <TableCell>{video.category}</TableCell>
                <TableCell>{video.subCategory}</TableCell>
                <TableCell>{video.createdBy?.name || video.createdBy?.username}</TableCell>
                <TableCell>
                  <Chip
                    label={video.status}
                    color={statusColor[video.status] || "default"}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Box display="flex" gap={1}>
                    <Tooltip title="Edit">
                      <IconButton color="primary" onClick={() => handleOpenDialog(video)} size="small">
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton color="error" onClick={() => handleDelete(video._id)} size="small">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
        />
        <Select
          value={limit}
          onChange={(e) => {
            setLimit(e.target.value);
            setPage(1);
          }}
          size="small"
        >
          {[5, 10, 20, 50].map((l) => (
            <MenuItem key={l} value={l}>{l} per page</MenuItem>
          ))}
        </Select>
      </Stack>

      {/* Edit Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Video</DialogTitle>
        <DialogContent>

          {/* Preview in dialog too */}
          {formData.videoUrl && (
            <Box sx={{ mb: 2 }}>
              {formData.videoUrl.includes("youtube.com") || formData.videoUrl.includes("youtu.be") ? (
                <img
                  src={`https://img.youtube.com/vi/${getYouTubeId(formData.videoUrl)}/0.jpg`}
                  alt="preview"
                  style={{ width: "160px", borderRadius: ".4rem" }}
                />
              ) : (
                <video src={formData.videoUrl} width="160" controls />
              )}
            </Box>
          )}

          <TextField
            label="Title"
            fullWidth
            margin="dense"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          />

          <TextField
            label="Video URL"
            fullWidth
            margin="dense"
            value={formData.videoUrl}
            onChange={(e) => setFormData({ ...formData, videoUrl: e.target.value })}
            disabled={!!formData.videoFile}
          />

          <Box mt={2} mb={1}>
            <input
              type="file"
              accept="video/*"
              onChange={(e) => setFormData({ ...formData, videoFile: e.target.files[0] })}
              disabled={!!formData.videoUrl}
            />
          </Box>

          <TextField
            label="Category"
            select
            fullWidth
            margin="dense"
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value, subCategory: "" })}
          >
            {categories.map(cat => (
              <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>
            ))}
          </TextField>

          <TextField
            label="SubCategory"
            select
            fullWidth
            margin="dense"
            value={formData.subCategory}
            onChange={(e) => setFormData({ ...formData, subCategory: e.target.value })}
            disabled={!formData.category}
          >
            <MenuItem value="">Select Sub Category (Optional)</MenuItem>
            {subcategories.map(sub => (
              <MenuItem key={sub._id} value={sub._id}>{sub.name}</MenuItem>
            ))}
          </TextField>

          <TextField
            label="Status"
            select
            fullWidth
            margin="dense"
            value={formData.status}
            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
          >
            <MenuItem value="pending_approval">Pending</MenuItem>
            <MenuItem value="posted">Posted</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">Update</Button>
        </DialogActions>
      </Dialog>

      {/* Video Player Modal */}
      <Dialog open={openPlayer} onClose={handleClosePlayer} maxWidth="md" fullWidth>
        <DialogTitle>
          Video Player
          <IconButton
            aria-label="close"
            onClick={handleClosePlayer}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {currentVideoUrl.includes("youtube.com") || currentVideoUrl.includes("youtu.be") ? (
            <iframe
              width="100%"
              height="400px"
              src={`https://www.youtube.com/embed/${getYouTubeId(currentVideoUrl)}`}
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video src={currentVideoUrl} width="100%" height="400px" controls autoPlay />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AllVideosAdminManagement;